var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManterForma(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24.982 24.982",
    style: {
      enableBackground: "new 0 0 24.982 24.982"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#929FB1"
    },
    d: "M15.423,14.346c-2.715,0-4.917,2.198-4.917,4.917c0,2.716,2.204,4.921,4.917,4.921 c2.719,0,4.922-2.205,4.922-4.921S18.141,14.346,15.423,14.346z M15.423,23.419c-2.293,0-4.156-1.857-4.156-4.153 c0-2.3,1.863-4.156,4.156-4.156c2.299,0,4.158,1.856,4.158,4.156C19.581,21.56,17.721,23.419,15.423,23.419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#929FB1"
    },
    d: "M14.457,20.144c-0.065,0-1.069-1.067-1.069-1.067l-0.626,0.628l1.697,1.687l3.635-3.621 l-0.627-0.628C17.462,17.14,14.523,20.144,14.457,20.144z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#929FB1"
    },
    cx: 10.011,
    cy: 2.205,
    r: 2.205
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#929FB1"
    },
    d: "M10.153,20.473v3.26l0.01,0.01c0.006,0.687,0.564,1.237,1.249,1.237 c0.645,0,1.166-0.488,1.237-1.111c-0.085-0.051-0.173-0.092-0.255-0.146C11.283,22.973,10.468,21.819,10.153,20.473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#929FB1"
    },
    d: "M12.408,14.722c0.078-0.057,0.169-0.096,0.251-0.145V7.888h0.604v5.047h0.004 c0,0.003,0,0.005,0,0.007c0,0.516,0.414,0.931,0.933,0.931c0.517,0,0.931-0.415,0.931-0.931c0-0.002,0-0.004,0-0.007V7.507 c-0.206-2.419-3.014-2.384-3.014-2.384H7.693c-3.168,0.06-3.056,2.384-3.056,2.384v5.432H4.64 c-0.001,0.009-0.003,0.023-0.003,0.034c0,0.517,0.419,0.934,0.932,0.934c0.515,0,0.931-0.417,0.931-0.934 c0-0.014-0.002-0.025-0.003-0.038H6.5V7.912h0.581L7.075,23.723c0,0.693,0.562,1.259,1.258,1.259c0.693,0,1.258-0.563,1.258-1.259 L9.59,13.521h0.562v4.457C10.472,16.627,11.288,15.47,12.408,14.722z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManterForma);
export default __webpack_public_path__ + "static/media/manter-forma.75eea6be09ace22b4910555e6facc287.svg";
export { ForwardRef as ReactComponent };